define([
    "./hereMapsModule"
], function (hereMapsModule) {
    "use strict";

    hereMapsModule.service("hereMapsActionsService", [
        function () {
            return{
                fullScreen: fullScreen,
                isFullScreen: isFullScreen
            };

            function isFullScreen() {
                return document.fullscreenElement;
            }

            function fullScreen(element) {
                if (! isFullScreen() ) {
                    return fullScreenService(element);
                }
                return exitFullScreenService();
            }

            function fullScreenService(element) {
                if (element.requestFullscreen) {
                    return element.requestFullscreen();
                }
            }

            function exitFullScreenService() {
                if (document.exitFullscreen) {
                    return document.exitFullscreen();
                }
            }
        }
    ]);
});